// 旧UIと同じ計算結果を返すことを最優先（パリティ維持版）
export function computeRotationRate({
  normalSpins,
  totalOutput,
  finalDifference,
  chanceSpins = 0,
  decreaseRate,
  ballsPer1000Yen,
  isDetail = true,
}) {
  const ns = toNum(normalSpins);
  const out = toNum(totalOutput);
  const diff = toNum(finalDifference);
  const ch = toNum(chanceSpins);
  const dec = toNum(decreaseRate);
  const perK = toNum(ballsPer1000Yen);

  // 旧ロジックのまま
  const inv = isDetail ? (out - diff - ch * dec) / perK : ((out - diff) * (1 - dec)) / perK;

  if (!Number.isFinite(inv) || inv <= 0) {
    return null; // 旧UIと同じ挙動：「計算不能（投資が0以下）」
  }
  const rate = ns / inv; // 回転/K
  return { rate, investment: inv };
}

function toNum(x) {
  const v = Number(x);
  return Number.isFinite(v) ? v : NaN;
}
